export enum AutocompleteAccountsTypeEnum {
    ACCOUNTS,
    CENTRAL_SHIPPING,
}
